import { render, staticRenderFns } from "./Pickup.vue?vue&type=template&id=4ad8e645"
import script from "./Pickup.vue?vue&type=script&lang=ts"
export * from "./Pickup.vue?vue&type=script&lang=ts"
import style0 from "./Pickup.vue?vue&type=style&index=0&id=4ad8e645&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports